import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Embedded Systems Foundations & Architecture Basics",
    description:
      "Embedded system & Architecture of embedded devices (CPU memory peripherals), Real-time systems vs general-purpose systems, Understanding microprocessors vs microcontrollers, Practical examples: automotive medical robotics consumer electronics",
  },
  {
    title: "Digital Electronics & Hardware Fundamentals",
    description:
      "Logic gates flip-flops registers, Combinational & sequential circuits, ADC/DAC basics, Timers counters & interrupts, Designing simple digital circuits for embedded projects",
  },
  {
    title: "Microcontroller Architecture & Interfacing",
    description:
      "Introduction to popular MCUs: 8051 AVR PIC ARM Cortex, Pin configuration internal modules & memory organization, GPIO programming, Interfacing buttons LEDs motors & displays, Hands-on embedded coding for hardware control",
  },
  {
    title: "Embedded C Programming & Firmware Development",
    description:
      "Introduction to C for embedded systems, Pointers structures & memory manipulation, Writing efficient low-level firmware, Managing concurrency delays & timing, Debugging embedded code using simulators & hardware tools",
  },
  {
    title: "Communication Protocols & Peripheral Interfacing",
    description:
      "I2C SPI UART CAN USB basics, Real-world sensor communication, Reading & writing data to peripherals, Designing multi-device embedded communication systems, Practical interfacing with temperature motion & pressure sensors",
  },
  {
    title: "Real-Time Operating Systems (RTOS) Essentials",
    description:
      "RTOS & it’s uses, Tasks scheduling & priorities, Inter-task communication (queues semaphores), Implementing concurrent task execution, Building a basic RTOS-based embedded application",
  },
  {
    title: "Embedded Linux & System Programming (Optional Track)",
    description:
      "Introduction to Linux for embedded devices, File systems bootloaders & kernel basics, Shell scripting & system-level programming, Working with Raspberry Pi / BeagleBone, Creating Linux-based IoT/automation applications",
  },
  {
    title: "Sensors, Actuators & Embedded Control Systems",
    description:
      "Interfacing with analog & digital sensors, Motors relays solenoids & actuators control, PID control basics for automation, Signal conditioning & noise reduction, Building embedded control loops for robotics & industrial use",
  },
  {
    title: "Testing, Debugging & Hardware Tools",
    description:
      "Using logic analyzers oscilloscopes & multimeters, Embedded debugging techniques (JTAG SWD), Hardware troubleshooting workflow, Power management & noise handling, Ensuring reliability in embedded devices",
  },
  {
    title: "Capstone Embedded Project & Career Preparation",
    description:
      "Building a complete embedded system (hardware + firmware + communication), Documentation & PCB basics introduction, Creating an industry-ready portfolio, GitHub project showcasing, Interview prep for Embedded Engineer Firmware Developer & Hardware Engineer roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
